import * as types from '../../index';

export const keyLocationListAction = (data) => {
    return {
    type: types.KEY_LOCATION_LIST,
    data
    }
};

export const keyLocationAddAction = (data) => {
    return {
    type: types.KEY_LOCATION_ADD,
    data
    }
};

export const keyLocationViewAction = (data) => {
    return {
    type: types.KEY_LOCATION_VIEW,
    data
    }
};

export const keyLocationDeleteAction = (data) => {
    return {
    type: types.KEY_LOCATION_DELETE,
    data
    }
};


export const eventLocationListAction = (data) => {
    return {
    type: types.EVENT_LOCATION_LIST,
    data
    }
};

export const eventLocationAddAction = (data) => {
    return {
    type: types.EVENT_LOCATION_ADD,
    data
    }
};

export const eventLocationViewAction = (data) => {
    return {
    type: types.EVENT_LOCATION_VIEW,
    data
    }
};

export const eventLocationDeleteAction = (data) => {
    return {
    type: types.EVENT_LOCATION_DELETE,
    data
    }
};

export const eventLocationImportAction = (data) => {
    return {
    type: types.EVENT_LOCATION_IMPORT,
    data
    }
};